module.exports = __webpack_public_path__ + "img/ly.df3155b9.svg";